var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMiniLiveChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2611_11799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 57.1428C0.346303 59.0357 1.45326 60 3.11411 60C3.84493 60 4.33209 59.7689 4.87881 59.3877L11.211 53.9796C11.211 53.9796 34.9002 54.2352 36.7471 53.9796C38.594 53.7239 39.5016 52.7833 39.6536 51.0204C39.7246 50.1987 39.7294 44.956 39.7143 39.5919H39.6536C36.1118 39.3879 34.2449 38.9746 31.1416 37.653C28.3411 36.1864 27.0162 35.1474 24.9132 33.0612C22.935 30.6346 21.9693 29.2006 20.8648 26.3265C20.5829 25.4953 20.3723 24.7819 20.2121 24.0817H3.11411C1.06249 24.3468 0.403072 25.0186 0 27.1429V57.1428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5396 24.0817C38.6171 24.4064 39.3186 25.0754 39.6538 27.1429C39.6538 27.1429 39.6972 33.447 39.7144 39.5919H56.8855C57.1885 39.5758 57.3724 39.5575 57.6121 39.4898C58.4387 39.2111 58.7977 38.9855 59.273 38.4694C59.8445 37.7157 59.9777 37.2908 59.9996 36.5306V19.5919C59.9499 17.4762 59.7526 16.4081 59.273 14.5919C58.4698 11.9108 57.7981 10.6016 56.3665 8.46942C54.9207 6.57444 54.0497 5.58877 52.2142 4.18367C50.7012 3.1003 49.8087 2.5451 48.0621 1.7347C47.2263 1.37953 46.7523 1.19361 45.8822 0.918432C43.6075 0.308803 42.3047 0.0558043 39.8614 0C36.7835 0.0810948 34.9614 0.376428 31.3494 1.83678C29.0786 3.04441 27.9106 3.76124 26.2629 5.20409C24.366 7.068 23.4488 8.13306 22.3183 10.102C21.5211 11.6348 21.1174 12.5188 20.5536 14.1837C19.9498 16.4883 19.7323 17.7661 19.7231 20C19.8072 21.6869 19.9336 22.8644 20.2122 24.0817H36.5396Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2611_11799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMiniLiveChat);
export default __webpack_public_path__ + "static/media/logoMiniLiveChat.d6c309abf710cb81b561adc5efc3c7b0.svg";
export { ForwardRef as ReactComponent };